<template>
  <IngredientCardPopover>
    <template #items>
      <IngredientCardPopoverItem
        v-for="section in sections"
        :key="section.title"
        :title="section.title"
        :items="section.items"
      />  
    </template>
    <img
      src="https://cdn.shopify.com/s/files/1/1209/5722/files/card-wholegrain.webp"
      alt="Whole Grain"
      width="229"
      class="object-contain"
    >
  </IngredientCardPopover>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import IngredientCardPopover from './ingredient-card-popover.vue'
import IngredientCardPopoverItem from './ingredient-card-popover-item.vue'
import { ingredientCards, visibleSections, type Page } from '@/utils/ingredient-cards'

export interface Props {
  page?: Page
}

const props = defineProps<Props>()

const sections = computed(() => visibleSections(ingredientCards.find(card => card.id === 2)!.sections, props.page))
</script>
